/* eslint-disable import/prefer-default-export */
import asyncService from '../../../../datahub/asyncService';

/**
 * Service for handling position template API operations
 */
export class PositionTemplateApiService {
  /**
   * Loads position templates for a specific corporation
   * @param {string} corporationId - The corporation ID
   * @param {Object} user - User object with token and refreshToken
   * @param {Function} dispatch - Redux dispatch function
   * @param {Function} onSuccess - Success callback
   * @param {Function} onError - Error callback
   */
  static async loadPositionTemplates(corporationId, user, dispatch, onSuccess, onError) {
    return asyncService({
      httpMethod: 'POST',
      route: 'position-templates/read',
      data: {
        limit: 100, // FIXME: Make it paginated or fetch all at once or find another solution
        page: 0,
        filters: [
          {
            field: 'corporation._id',
            value: corporationId,
            operation: 'equalsID',
          },
          {
            field: 'approved',
            value: true,
            operation: 'equals',
          },
        ],
      },
      onSuccess,
      onError,
      dispatch,
      token: user?.token,
      refreshToken: user?.refreshToken,
    });
  }
}
